import { FunctionComponent, useCallback } from "react";
import { MenuItemWithDescription } from "src/components/Menus/MenuItemWithDescription";
import * as FSQ from "src/generated/hooks/form-service/queries";
import { useAvelaToast } from "src/hooks/useAvelaToast";
import { triggerDownload } from "src/services/dataTransfer";

type Props = {
  enrollmentPeriodId: uuid;
};

export const ExportSchoolMenuItem: FunctionComponent<Props> = (props) => {
  const { enrollmentPeriodId } = props;

  const toast = useAvelaToast();

  const service = FSQ.useExportSchoolsAndGradesForEnrollmentPeriod(
    {
      path: {
        enrollmentPeriodId,
      },
    },
    ["exportSchoolsAndGradesForEnrollmentPeriod", enrollmentPeriodId],
    {
      enabled: false,
    }
  );

  const handleOnExportClick = useCallback(async () => {
    const loadingToastId = toast({
      title: "Export in progress",
      description: "Download will start shortly",
      status: "loading",
    });

    const response = await service.refetch();

    if (!response.data?.data) {
      toast.genericError();
      return;
    }

    try {
      triggerDownload(
        new Blob([JSON.stringify(response.data?.data.schools, undefined, 2)], {
          type: "application/json",
        }),
        "enrollmentPeriodSchoolsAndGrades.json"
      );
      toast.close(loadingToastId);
      toast({
        title: "Enrollment period schools and grades exported",
        status: "success",
      });
    } catch (e) {
      toast.close(loadingToastId);
      toast.error({
        title: "Something went wrong!",
        description: "Check your network and try again",
      });
      console.error(e);
    }
  }, [toast, service]);

  return (
    <MenuItemWithDescription
      title="Schools to JSON file"
      description="Export this period's schools to a file"
      onClick={handleOnExportClick}
    />
  );
};
